

import { Get, GetWithAccessToken, PostAndGetFileInResponse, PostWithAccessToken } from '../../../helpers/http';
import { CURRENT_CONFIG } from '../../../helpers/Util';


export const getMinorConsentForm = async (caseId, cmpId) => {
    return (await GetWithAccessToken(`${process.env.REACT_APP_DOCTOR_API_URL}MinorConsentForm/Get?CaseId=${caseId}&CompanyId=${cmpId}&FormName=MinorParent`))
        .json();
};

export const saveMinorConsent = async (data) => {
    return (await PostWithAccessToken(`${process.env.REACT_APP_DOCTOR_API_URL}MinorConsentForm/Save`, data)).json()
    // return (await PostWithAccessToken(`http://localhost:9002/api/MinorConsentForm/Save`, data)).json()
    
};

export const saveParentSignatue = async (data) => {
    return (await PostWithAccessToken(`${process.env.REACT_APP_DOCTOR_API_URL}MinorConsentForm/ParentSign`, data)).json()
};

export const getOfficeList = async (cmpId) => {
        return (await Get(`${process.env.REACT_APP_DOCTOR_API_URL}CommonList/GetOfficeList?companyId=${cmpId}`))
        .json();
};

export const getInsuranceCompanys = async (cmpId) => {
    return (await Get(`${process.env.REACT_APP_DOCTOR_API_URL}Patient/GetInsuranceCompanyList?companyId=${cmpId}`))
        .json();
};

export const getPdfForPrint = async (data) => {
    return (await PostAndGetFileInResponse(`${CURRENT_CONFIG.API}MinorConsentForm/PrintPDF`, data))
        .arrayBuffer();
};